import { create } from 'zustand';

export interface Integrador {
  _id: string;
  nome: string;
  email: string;
  empresa: string;
  alias: string;
  logo_url?: string;
  company_branding_logo_url?: string | null;
  company_trade_name?: string | null;
  company_business_name?: string | null;
  plano: 'free' | 'pro' | 'enterprise';
  commercialPlan?: {name:string;code:string} | null;
  status: 'ativo' | 'inativo' | 'suspenso';
  namespace_k8s?: string;
  git_frontend_repo?: string;
  git_backend_repo?: string;
  git_branch?: string;
  data_criacao: string;
}

export interface Instancia {
  _id: string;
  integrador_id: string;
  nome: string;
  namespace_k8s?: string;
  status: 'criando' | 'ativo' | 'erro' | 'deletado';
  logs?: string;
  frontend_url: string;
  backend_url: string;
  company_branding_logo_url?: string | null;
  company_trade_name?: string | null;
  company_business_name?: string | null;
  mongodb_uri: string;
  replicas_frontend?: number;
  replicas_backend?: number;
  data_criacao: string;
}

interface Store {
  integradores: Integrador[];
  instancias: Instancia[];
  loading: boolean;
  error: string | null;

  setIntegradores: (integradores: Integrador[]) => void;
  setInstancias: (instancias: Instancia[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  addIntegrador: (integrador: Integrador) => void;
  removeIntegrador: (id: string) => void;
}

export const useStore = create<Store>((set) => ({
  integradores: [],
  instancias: [],
  loading: false,
  error: null,

  setIntegradores: (integradores) => set({ integradores }),
  setInstancias: (instancias) => set({ instancias }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  addIntegrador: (integrador) =>
    set((state) => ({
      integradores: [...state.integradores, integrador],
    })),
  removeIntegrador: (id) =>
    set((state) => ({
      integradores: state.integradores.filter((int) => int._id !== id),
    })),
}));
